/**
 * Prints one rendered element (an assistant reply, visuals included) through
 * the browser's print dialog, where "Save as PDF" makes the file. The element
 * is cloned into a hidden frame with the app's stylesheets, so charts, pages
 * and diagrams print as they look; buttons are dropped, every carousel slide
 * and tab is shown, and it prints in light mode.
 */ const PRINT_CSS = `
@page { margin: 16mm; }
body { padding: 0; margin: 0; }
[hidden] { display: block !important; }
* { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
`;
function escapeHtml(s) {
    return s.replace(/[&<>"']/g, (c)=>`&#${c.charCodeAt(0)};`);
}
/** The printable document for an element: its clone, the app's styles, and the title. */ export function buildPrintDocument(el, title, headHtml) {
    const clone = el.cloneNode(true);
    for (const n of clone.querySelectorAll('button, [data-print-hide]'))n.remove();
    return `<!doctype html><html lang="en"><head><meta charset="utf-8"><title>${escapeHtml(title)}</title>` + `${headHtml}<style>${PRINT_CSS}</style></head>` + `<body class="bg-background text-foreground">${clone.outerHTML}</body></html>`;
}
export function printElement(el, title) {
    const headHtml = [
        ...document.querySelectorAll('link[rel="stylesheet"], style')
    ].map((n)=>n.outerHTML).join('');
    const frame = document.createElement('iframe');
    frame.setAttribute('aria-hidden', 'true');
    frame.tabIndex = -1;
    Object.assign(frame.style, {
        position: 'fixed',
        right: '0',
        bottom: '0',
        width: '0',
        height: '0',
        border: '0'
    });
    const cleanup = ()=>frame.remove();
    frame.onload = ()=>{
        const win = frame.contentWindow;
        if (!win) return cleanup();
        win.addEventListener('afterprint', cleanup);
        // Give images (page renders) a beat to decode before the dialog opens.
        window.setTimeout(()=>{
            win.focus();
            win.print();
            window.setTimeout(cleanup, 60000);
        }, 250);
    };
    frame.srcdoc = buildPrintDocument(el, title, headHtml);
    document.body.appendChild(frame);
}
